import React from "react";
import TableBase from "./Base";
import moment from "moment";
import { Button } from "antd";

import { DATE_FORMAT_FRONTEND } from "../../constants";
import { getTranslation } from "../../utils/helper";

const UsersTable = ({ scrollHeight, actionWidth, withAction, setting, ...props }) => {
  const COLUMNS = [
    {
      title: getTranslation(setting, "Users", "User Name"),
      dataIndex: "name",
      width: 150,
      ellipsis: true,
    },
    {
      title: getTranslation(setting, "Users", "User Groups"),
      dataIndex: "groups",
      width: 400,
      ellipsis: true,
      render(groups) {
        if (!groups) return null;
        return groups.map(group => (
          <Button key={group._id} type="text" className="group">
            {group.name}
          </Button>
        ));
      },
    },
    {
      title: getTranslation(setting, "Users", "Created Date"),
      dataIndex: "createdAt",
      width: 150,
      ellipsis: true,
      render(value) {
        return value ? moment(value).locale(setting.systemLanguage).format(DATE_FORMAT_FRONTEND) : "-";
      },
    },
    {
      title: getTranslation(setting, "Users", "Email"),
      dataIndex: "email",
      width: 150,
      ellipsis: true,
    },
  ];

  if (withAction) {
    COLUMNS.push({
      key: "action",
      width: actionWidth || 100,
      fixed: "right",
      render(record) {
        return withAction(record);
      },
    });
  }

  if (scrollHeight) {
    return <TableBase columns={COLUMNS} scroll={{ x: 991, y: scrollHeight }} {...props} />;
  } else {
    return <TableBase columns={COLUMNS} scroll={{ x: 991 }} {...props} />;
  }
};

export default UsersTable;
